export const logSagaError = (message: string, error: unknown) => {
    console.error(message, error);
};

export class BadRequestError extends Error {}
